const password_length = 8;

const passwordChecks = {
  capital: function (value) { return /[A-Z]/.test(value); },
  lowercase: function (value) { return /[a-z]/.test(value); },
  number: function (value) { return /[0-9]/.test(value); },
  special: function (value) { return /[^A-Za-z0-9]/.test(value); },
  length: function (value) { return value.length >= password_length; }
};

function validateForm(form_submit) {
  const form = form_submit.closest(`form`);
  const inputs = form.querySelectorAll(`input[data-validate]`);
  let all_inputs_valid = true;
  clearFormErrors(form);
  for (const input of inputs) {
    const input_valid = validateInput(input, true);
    if (!input_valid) {
      all_inputs_valid = false;
    }
  }
  if (all_inputs_valid) {
    form.submit();
  }
}

function validateInput(input, validate_all = false) {
  const form = input.closest(`form`);
  const rules = input.dataset.validate?.split(`|`) || [];
  let inputPassedValidation = true;

  if (!validate_all) {
    clearFormErrors(form);
  }

  for (let rule of rules) {
    if (rule.startsWith('match:')) {
      const targetSelector = rule.split(':')[1];
      const matchInput = form.querySelector(targetSelector);
      if (input.value !== matchInput?.value) {
        showFormError(form, 'Passwords do not match.');
        inputPassedValidation = false;
      }
    } else if (rule === 'password') {
      const is_empty = input.value === ``;
      if (is_empty) {
        showFormError(form, 'Please enter your password.');
        inputPassedValidation = false;
      } else {
        const valid = updatePasswordFeedback(input);
        if (!valid) {
          showFormError(form, 'Your password must include an uppercase letter, a lowercase letter, a number, and a special character.');
          inputPassedValidation = false;
        }
        const password_too_short = input.value.length < password_length;
        if (password_too_short) {
          showFormError(form, `Password must be at least ${password_length} characters long.`);
          inputPassedValidation = false;
        }
        const password_too_long = input.value.length > 40;
        if (password_too_long) {
          showFormError(form, `Password must be 40 characters or fewer.`);
          inputPassedValidation = false;
        }
      }
    } else if (rule === 'required' && input.value.trim() === '') {
      showFormError(form, 'This field is required.');
      inputPassedValidation = false;
    } else if (rule === 'email') {
      const is_empty = input.value === ``;
      if (is_empty) {
        showFormError(form, 'Please enter your email address.');
        inputPassedValidation = false;
      } else {
        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value);
        if (!isEmail) {
          showFormError(form, `That doesn't look like a valid email. Try again.`);
          inputPassedValidation = false;
        }
        const email_too_long = input.value.length > 254;
        if (email_too_long) {
          showFormError(form, `Email must be 254 characters or fewer.`);
          inputPassedValidation = false;
        }
      }
    } else if (rule === `first_name`) {
      const is_empty = input.value === ``;
      if (is_empty) {
        showFormError(form, 'Please enter your first name.');
        inputPassedValidation = false;
      } else {
        const is_valid = /^.{2,}$/.test(input.value);
        if (!is_valid) {
          showFormError(form, 'Your first name must be at least 2 characters long.');
          inputPassedValidation = false;
        }
        const character_test = /^[a-zA-Z'.-]+$/.test(input.value);
        if (!character_test) {
          showFormError(form, `Please enter a valid first name using only letters, apostrophes, hyphens (for double names), and periods (e.g., ‘Jr.’)`);
          inputPassedValidation = false;
        }
      }
    } else if (rule === `last_name`) {
      const is_empty = input.value === ``;
      if (is_empty) {
        showFormError(form, 'Please enter your last name.');
        inputPassedValidation = false;
      } else {
        const is_valid = /^.{2,}$/.test(input.value);
        if (!is_valid) {
          showFormError(form, 'Your last name must be at least 2 characters long.');
          inputPassedValidation = false;
        }
        const character_test = /^[a-zA-Z'.-]+$/.test(input.value);
        if (!character_test) {
          showFormError(form, `Please enter a valid first name using only letters, apostrophes, hyphens (for double names), and periods (e.g., ‘Jr.’)`);
          inputPassedValidation = false;
        }
      }
    }
  }
  return inputPassedValidation;
}

function updatePasswordFeedback(input) {
  const container = input.closest(`[data-input-container]`).querySelector(`[data-password-rules]`);
  if (!container) return;
  let allCasesPassed = true;

  for (const key in passwordChecks) {
    const passed = passwordChecks[key](input.value);
    const rule = container.querySelector(`[data-password-rule-${key}]`);
    if (rule) {
      rule.querySelector(`[data-password-rule-${key}-success]`).classList.toggle(`hidden`, !passed);
      rule.querySelector(`[data-password-rule-${key}-fail]`).classList.toggle(`hidden`, passed);
      if (!passed) { allCasesPassed = false; }
    }
  }
  return allCasesPassed;
}

function showFormError(form, message) {
  const errorContainer = form.querySelector('[data-form-errors]');
  if (errorContainer) {
    const span = document.createElement(`span`);
    span.className = `text-error text-tiny mt-2.5 block`;
    span.textContent = message;
    errorContainer.appendChild(span);
  }
}
function clearFormErrors(form) {
  const container = form.querySelector(`[data-form-errors]`);
  if (container) container.innerHTML = ``;
}